module.exports = __webpack_public_path__ + "img/logo.252d0afb.svg";